import styles from "./ErrorValidate.module.scss";

interface ErrorValidateProps {
    errorMessage?: string;
}
export const ErrorValidate = ({ errorMessage }: ErrorValidateProps) => {
    if (!errorMessage) return null;
    return <p className={styles.error}>{errorMessage}</p>;
};
